module.exports = __webpack_public_path__ + "static/media/Servietten_40x40_4erSet.936fff49.png";